import { render } from "./scroll-progress.vue?vue&type=template&id=474a922d"
import script from "./scroll-progress.vue?vue&type=script&lang=js"
export * from "./scroll-progress.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__